export default __webpack_public_path__ + "static/media/skill-delivery.773068d3.svg";